import { useState } from "react";
import { ApiClientError } from "../../lib/api/client";
import { useRejectExpenseMutation } from "../../lib/api/transactions";
import { Button } from "../../components/ui/Button";
import { Modal } from "../../components/ui/Modal";

interface RejectExpenseModalProps {
  open: boolean;
  onClose: () => void;
  expenseId: string;
  onRejected: () => void;
}

export function RejectExpenseModal({
  open,
  onClose,
  expenseId,
  onRejected,
}: RejectExpenseModalProps) {
  const rejectExpense = useRejectExpenseMutation();
  const [reason, setReason] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function confirm() {
    setError(null);
    try {
      await rejectExpense.mutateAsync({ id: expenseId, reason });
      onRejected();
      onClose();
      setReason("");
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "Could not reject expense.");
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Return expense to creator"
      description="Explain what needs to be corrected."
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={rejectExpense.isPending || !reason.trim()}
            onClick={() => void confirm()}
          >
            Reject expense
          </Button>
        </>
      }
    >
      {error ? <p className="edlab-error mb-4">{error}</p> : null}
      <label className="form-field">
        Reason
        <textarea
          className="edlab-textarea"
          rows={4}
          value={reason}
          placeholder="Please describe the change needed…"
          onChange={(event) => {
            setReason(event.target.value);
          }}
        />
      </label>
    </Modal>
  );
}
